module.exports = __webpack_public_path__ + "static/media/imagesnew.485efbf9.jpg";